import React from 'react';

export const LeftIcon = ({ width = 24, height = 24, color = '#000' }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7071 5L16.1213 6.41421L10.8284 11.7071L16.1213 17L14.7071 18.4142L8 11.7071L14.7071 5Z"
      fill={color}
    />
  </svg>
);
